import { DOMAIN } from './OrganizationsList.constants';
import get from 'lodash/get';

export const getStore = state => get(state, DOMAIN) || {};

export const getResults = state => getStore(state).results || [];
export const getResultCount = state => getStore(state).resultCount || 0;
export const getError = state => getStore(state).error;
export const getCreationError = state => getStore(state).creationError;
export const getPlanData = state => getStore(state).planData || {};
export const getPlanLimitReached = () => false; // planLimitReached(getPlanData(state));

export const getRequestFilters = state => getStore(state).filters || {};
export const hasFilters = state =>
    Object.values(getRequestFilters(state)).reduce(
        (hasFilters, filters) => hasFilters || filters.length,
        false
    );

export const getRequestParams = state => {
    const { offset, limit, query } = getStore(state);
    return {
        offset,
        limit,
        query,
    };
};

export const isLoading = state => getStore(state).loading;
export const isCreating = state => getStore(state).creating;
